module.exports = __webpack_public_path__ + "img/mint10-rollover.4083a408.png";